"use client";

import { Button, buttonVariants } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { glassCardVariants } from "./glass-card";
import { cn } from "@/lib/utils";

export default function BackButton({
  text = "Back",
  className,
  showText = true,
  isBtn = false,
}: {
  text?: string;
  className?: string;
  showText?: boolean;
  isBtn?: boolean;
}) {
  const btnClassName = isBtn
    ? buttonVariants({
        variant: "outline",
        className: cn("absolute left-4 top-4", className),
      })
    : glassCardVariants({
        className: cn("absolute left-4 top-4", className),
      });
  return (
    <div className={btnClassName} onClick={() => window.history.back()}>
      <ArrowLeft />
      {showText && text}
    </div>
  );
}
